import { render, staticRenderFns } from "./FeeScheduleAndInterestRates.vue?vue&type=template&id=47be1b6e&scoped=true"
import script from "./FeeScheduleAndInterestRates.vue?vue&type=script&lang=ts"
export * from "./FeeScheduleAndInterestRates.vue?vue&type=script&lang=ts"
import style0 from "./FeeScheduleAndInterestRates.vue?vue&type=style&index=0&id=47be1b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be1b6e",
  null
  
)

export default component.exports